import { event_selected_store } from '@/utils/gtm';

const ShippingInfoBranchCard = ({
  branch,
  t,
  handleBranchSelect,
  selectedBranch,
}) => {
  return (
    <div
      className={`mb-4 rounded-2xl border p-4 max-sm:p-2 ${selectedBranch?.id == branch?.id ? 'border-2 border-[#1e2b55]' : 'border-gray-300'}`}
    >
      <div className='flex items-start justify-between gap-3'>
        <div className='flex flex-col gap-1'>
          <div className='text-base font-semibold'>{branch?.name}</div>
          {branch?.address && (
            <div className='flex items-center gap-2 text-xs text-gray-500'>
              <span className='max-sm:line-clamp-2 max-sm:w-27'>
                {branch?.address}
              </span>
              <a
                href={`https://maps.google.com/maps/dir/?api=1&destination=${branch?.lat},${branch?.lng}`}
                target='_blank'
                rel='noopener noreferrer'
                className='rounded px-2 py-0.5 text-[11px] font-medium text-white'
                style={{ backgroundColor: '#1e2b55' }}
              >
                {t('google_address')}
              </a>
            </div>
          )}
          {branch?.open_time_hours && (
            <div className='mt-1 text-xs text-gray-600'>
              {branch?.open_time_hours}
            </div>
          )}
        </div>
        <div className='flex flex-col items-end gap-2'>
          <span
            className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${branch?.available ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-600'}`}
          >
            {branch?.available ? t('available') : t('not_available')}
          </span>

          <button
            onClick={() => {
              handleBranchSelect(branch);
              event_selected_store({
                branch_name: branch?.name,
              });
            }}
            className='rounded-lg border px-3 py-1.5 text-xs font-medium hover:bg-gray-50'
          >
            {t('choose')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShippingInfoBranchCard;
